var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.528 12.0935V14.4766C12.5256 14.8808 12.3646 15.2678 12.0797 15.5545C11.7948 15.8411 11.4088 16.0045 11.0047 16.0093H5.02336C4.61849 16.0069 4.23103 15.8443 3.94561 15.5571C3.66019 15.27 3.49999 14.8815 3.5 14.4766V4.52336C3.5 4.11934 3.6605 3.73187 3.94618 3.44618C4.23187 3.1605 4.61934 3 5.02336 3H11.0047C11.4079 3.00245 11.794 3.16374 12.0791 3.44889C12.3643 3.73405 12.5256 4.1201 12.528 4.52336V7.07477"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01404 9.50476H16.3505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2103 7.21484L17.5 9.61671L15.2103 11.7943"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/Logout.icon.0b6a0c4de2045daf9841c492937c9ee7.svg";
export { ForwardRef as ReactComponent };